module.exports = __webpack_public_path__ + "img/img_sfz4.e460ad97.png";